const concatenateArrays = (arrayOne: unknown[], arrayTwo: unknown[]) => {
  if (!Array.isArray(arrayOne) || !Array.isArray(arrayTwo)) return [];

  const concatArrays = arrayOne.concat(arrayTwo);
  return [...new Set(concatArrays)];
};

export default concatenateArrays;
